<script lang="ts">
	import { classes } from '$lib/utils';

	export let additionalClass: { label?: string; input?: string };
	export let checked: boolean;
	export let id: string;
	export let ariaLabel: string;
	export let hasError = false;
</script>

<div class="flex items-start">
	<div class="flex items-center h-5">
		<input
			aria-describedby={ariaLabel}
			{id}
			type="checkbox"
			class={classes(
				'w-4 h-4 cursor-pointer border border-black rounded checked:bg-purple focus:ring-3 focus:ring-purple',
				hasError ? 'ring-2 ring-error' : '',
				additionalClass?.input || ''
			)}
			bind:checked
		/>
	</div>
	<div class="ml-3 text-sm">
		<label for={id} class={classes('text-black cursor-pointer', additionalClass?.label || '')}>
			<slot />
		</label>
	</div>
</div>
